import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import user from "./modules/user";
import home from "./modules/home";
import ComponentConfig from "./modules/ComponentConfig";
Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

const store = new Vuex.Store({
  modules: {
    app,
    user,
    home,
    ComponentConfig
  },
  getters,
  plugins:[createPersistedState({ storage: window.sessionStorage })]
});

export default store;
